{
  "base": {
    "default": "terrain/grass_plain",
    "visualPolish": {
      "asset": "sk/grass_plain_clean",
      "seasonal": "grass"
    },
    "variants": {
      "dark": "terrain/grass_meadow"
    }
  },
  "overlays": {
    "shore": {
      "asset": "water27/shallow_1"
    },
    "field": {
      "asset": "fields/wheat",
      "seasonal": "field"
    },
    "forest": {
      "assets": ["props/tree_pine", "props/tree_pine_alt"]
    },
    "mountain": {
      "asset": "environment/mountain_01"
    },
    "workyard": {
      "asset": "fields/plowed"
    }
  },
  "roads": {
    "visualPolish": {
      "horizontal": {
        "asset": "sk/road_h_overlay_clean"
      },
      "vertical": {
        "asset": "sk/road_v_overlay_clean"
      },
      "corner": {
        "asset": "sk/road_corner_overlay_clean"
      },
      "t": {
        "asset": "sk/road_t_overlay_clean"
      },
      "cross": {
        "asset": "sk/road_cross_overlay_clean"
      },
      "end": {
        "asset": "sk/road_end_overlay_clean"
      }
    },
    "composites": {
      "settlement": {
        "asset": "sk/road_composite_polished",
        "anchorX": 0,
        "anchorY": 0,
        "scaleX": 1,
        "scaleY": 1,
        "tileX": -0.5,
        "tileY": -0.5,
        "alpha": 1
      }
    }
  },
  "water": {
    "visualPolish": {
      "lake": {
        "asset": "sk/lake_deep",
        "seasonal": "lake_deep"
      },
      "lakeShore": {
        "asset": "sk/lake_shore",
        "seasonal": "lake_shore"
      },
      "lakeCorner": {
        "asset": "sk/lake_corner"
      },
      "riverHorizontal": {
        "asset": "sk/river_h",
        "seasonal": "river_h"
      },
      "riverVertical": {
        "asset": "sk/river_v",
        "seasonal": "river_v"
      },
      "riverBend": {
        "asset": "sk/river_bend",
        "seasonal": "river_bend"
      },
      "riverT": {
        "asset": "sk/river_t"
      },
      "riverCross": {
        "asset": "sk/river_cross"
      }
    },
    "default": {
      "deepA": "water27/sea_deep_1",
      "deepB": "water27/sea_deep_2",
      "riverHorizontal": "water27/river_h",
      "riverVertical": "water27/river_v",
      "shoreNorth": "water27/shore_north",
      "shoreSouth": "water27/shore_south",
      "shoreEast": "water27/shore_east",
      "shoreWest": "water27/shore_west",
      "shoreOuterNorthWest": "water27/shore_out_nw",
      "shoreOuterNorthEast": "water27/shore_out_ne",
      "shoreOuterSouthWest": "water27/shore_out_sw",
      "shoreOuterSouthEast": "water27/shore_out_se",
      "shallow": "water27/shallow_1"
    },
    "details": {
      "shore": ["water27/reeds_shore", "water27/fishing_spot"],
      "river": ["water27/rapids_1"]
    },
    "composites": {
      "source": {
        "asset": "sk/river_source_spring_matched_v2",
        "anchorX": 0.5,
        "anchorY": 0.58,
        "scaleX": 0.46,
        "scaleY": 0.46,
        "tileX": 22.95,
        "tileY": 4.65,
        "alpha": 1
      },
      "lake": {
        "asset": "sk/lake_river_style_v2",
        "anchorX": 0.5,
        "anchorY": 0.58,
        "scaleX": 0.8,
        "scaleY": 0.8,
        "tileX": 8.35,
        "tileY": 13.2
      },
      "river": {
        "asset": "sk/river_example_meander_varied",
        "anchorX": 0.52,
        "anchorY": 0.5,
        "scaleX": 1.04,
        "scaleY": 1.26,
        "tileX": 25.05,
        "tileY": 10.2,
        "alpha": 0.98
      }
    }
  },
  "overlaySizing": {
    "roadOverdraw": 26,
    "visualPolishWaterOverdraw": 8,
    "defaultOverdraw": 4
  }
}
